import { useAppState } from '../AppStateProvider';
import { LoadingView } from '../components/LoadingView';
import { SkeletonGroup } from '../components/LoadingView/LoadingView';
import { useCompanyQuery } from '../features/company/useCompanyQuery';
import { useContact } from '../features/contacts/useContact';
import { useDisabledPageView } from '../hooks/useDisabledPageView';
import { useIsWithinCrm } from '../hooks/useIsWithinCrm';
import { useIsWithinLinkedin } from '../hooks/useIsWithinLinkedin';

import { CompanyOverviewContainer } from './company-overview/CompanyOverviewContainer';
import { ContactItem } from './contacts/ContactItem';
import { StyledContactItem } from './contacts/ContactItem/styles';

export const ContactOverview = ({ onScrollToTop }: { onScrollToTop: () => void }) => {
  const { collectedContactInfo } = useAppState();
  const { isDisabledPageVisible, disabledPageView } = useDisabledPageView();
  const { isLoading: isLoadingContact, contact } = useContact();
  const { isLoading: isCompanyLoading } = useCompanyQuery();

  const isWithinLinkedin = useIsWithinLinkedin();
  const isWithinCrm = useIsWithinCrm();

  let hasCollectedCompanyData;
  if (isWithinLinkedin) {
    hasCollectedCompanyData = !!collectedContactInfo && collectedContactInfo?.numericCompanyLinkedinIds?.length !== 0;
  } else if (isWithinCrm) {
    hasCollectedCompanyData = !!collectedContactInfo?.site;
  }

  if (isDisabledPageVisible) {
    return disabledPageView;
  }

  const isContactAndCompanyLoading =
    isLoadingContact && (isCompanyLoading || (!isCompanyLoading && !hasCollectedCompanyData));

  if (isContactAndCompanyLoading) {
    return <LoadingView />;
  }

  return (
    <>
      {!contact || isLoadingContact ? (
        <StyledContactItem variant="singular">
          <SkeletonGroup />
        </StyledContactItem>
      ) : (
        <ContactItem contact={contact} variant="singular" />
      )}
      <CompanyOverviewContainer variant="card" onScrollToTop={onScrollToTop} />
    </>
  );
};
